import { render } from "./ColliEntrataTable.vue?vue&type=template&id=cd718d96&scoped=true"
import script from "./ColliEntrataTable.vue?vue&type=script&lang=js"
export * from "./ColliEntrataTable.vue?vue&type=script&lang=js"

import "./ColliEntrataTable.vue?vue&type=style&index=0&id=cd718d96&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd718d96"]])

export default __exports__